import { McpResponseModel } from '@/customApiClients/mgmtApiClient/Api';
import { cn } from '@/lib/utils';

import SourceTypeIcon from '@/components/icons/SourceTypeIcon';
import { Button } from '@/components/ui/button';

import { useIsMobile } from '@/hooks/use-mobile';

interface SourcesPillProps {
    sources: McpResponseModel[];
    onClick: () => void;
    disabled?: boolean;
}

const SourceAvatar = ({ configType }: { configType: string }) => (
    <div className="flex justify-center items-center bg-background -mr-2.5 sm:-mr-3 last:mr-0 p-1.5 sm:p-[5px] border border-border rounded-full [&_svg]:size-4">
        <SourceTypeIcon configType={configType} />
    </div>
);

const SourcesPill = ({ sources, onClick, disabled }: SourcesPillProps) => {
    const isMobile = useIsMobile();
    const hasSelection = sources.length > 0;
    const visibleSources = sources.slice(0, isMobile ? 1 : 3);

    return (
        <Button
            type="button"
            variant="secondary"
            onClick={onClick}
            disabled={disabled}
            aria-label="Sources"
            size="default"
            className={cn(
                'flex items-center gap-1.5 sm:gap-2.5',
                hasSelection ? 'px-1 pr-4 sm:pr-4' : 'px-2.5 sm:px-4'
            )}
        >
            {hasSelection && (
                <div className="flex items-center">
                    {visibleSources.map((source) => (
                        <SourceAvatar
                            key={source.name}
                            configType={source.configType}
                        />
                    ))}
                </div>
            )}
            <span
                className={cn(
                    'font-medium text-secondary-foreground text-xs sm:text-sm leading-4',
                    hasSelection && 'max-[510px]:hidden'
                )}
            >
                Sources
            </span>
            <span className="font-medium text-muted-foreground text-sm leading-4">
                {sources.length}
            </span>
        </Button>
    );
};

export default SourcesPill;
